/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { Bank__factory } from "./Bank__factory";
export { BankProxy__factory } from "./BankProxy__factory";
